/* tslint:disable */
/* eslint-disable */
export enum Role {
  AccessDenied = 0,
  Normal = 100,
  Administrator = 300,
  Admin = 444
}
